export const ANIMAL_SEO_TAXA = Object.freeze({
  'common-wombat': Object.freeze({ commonName: 'Common wombat', scientificName: 'Vombatus ursinus', group: 'Mammals', source: 'Catalogue of Life' }),
  'blue-whale': Object.freeze({ commonName: 'Blue whale', scientificName: 'Balaenoptera musculus', group: 'Mammals', source: 'Catalogue of Life' }),
  platypus: Object.freeze({ commonName: 'Platypus', scientificName: 'Ornithorhynchus anatinus', group: 'Mammals', source: 'Catalogue of Life' }),
  'monarch-butterfly': Object.freeze({ commonName: 'Monarch butterfly', scientificName: 'Danaus plexippus', group: 'Insects', source: 'Catalogue of Life' }),
  'saltwater-crocodile': Object.freeze({ commonName: 'Saltwater crocodile', scientificName: 'Crocodylus porosus', group: 'Reptiles', source: 'Catalogue of Life' }),
});

const QUESTIONS = Object.freeze({
  'what-is-the-scientific-name-of-the-common-wombat': Object.freeze({
    title: 'What is the scientific name of the common wombat?',
    answer: 'The accepted scientific name in the Animal Explorer taxonomy is Vombatus ursinus.',
    taxa: ['common-wombat'],
  }),
  'are-platypuses-mammals': Object.freeze({
    title: 'Are platypuses mammals?',
    answer: 'Yes. Animal Explorer places Ornithorhynchus anatinus in the class Mammalia.',
    taxa: ['platypus'],
  }),
});

function safeSlug(value) { return typeof value === 'string' && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value) ? value : null; }

export function buildAnimalSeoPage(kind, params = {}) {
  if (kind === 'species') {
    const slug = safeSlug(params.slug);
    const taxon = slug && ANIMAL_SEO_TAXA[slug];
    if (!taxon) return null;
    return { kind, title: `${taxon.commonName} (${taxon.scientificName})`, description: `Taxonomy and source-aware animal information for ${taxon.commonName}.`, taxa: [taxon] };
  }
  if (kind === 'compare') {
    const leftSlug = safeSlug(params.left); const rightSlug = safeSlug(params.right);
    const left = leftSlug && ANIMAL_SEO_TAXA[leftSlug]; const right = rightSlug && ANIMAL_SEO_TAXA[rightSlug];
    if (!left || !right || leftSlug === rightSlug) return null;
    return { kind, title: `${left.commonName} vs ${right.commonName}`, description: `A source-aware taxonomy comparison of ${left.commonName} and ${right.commonName}.`, taxa: [left, right] };
  }
  if (kind === 'question') {
    const slug = safeSlug(params.slug); const question = slug && QUESTIONS[slug];
    if (!question) return null;
    return { kind, title: question.title, description: question.answer, answer: question.answer, taxa: question.taxa.map((taxonSlug) => ANIMAL_SEO_TAXA[taxonSlug]) };
  }
  return null;
}

export function animalSeoPaths() {
  const species = Object.keys(ANIMAL_SEO_TAXA).map((slug) => `/animal-explorer/species/${slug}`);
  const questions = Object.keys(QUESTIONS).map((slug) => `/animal-explorer/questions/${slug}`);
  return [...species, ...questions];
}
